// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `::ng-deep .p-dialog .p-dialog-header {
  justify-content: space-between;
}

#sessionTimeout ::ng-deep .p-dialog {
  width: 40% !important;
}

.bdp-save {
  background-color: #2d74ff;
}

.bdp-reset {
  color: #1d2125;
  background-color: #fff;
  border-color: #1d2125;
}

.p-dialog .p-dialog-header {
  font-size: 1.5rem;
  font-weight: bold;
}

.p-dialog .p-button-primary {
  background-color: #007bff;
  border-color: #007bff;
  color: #fff;
}

.p-dialog .p-button-outlined {
  border-color: #ccc;
  color: #333;
}`, "",{"version":3,"sources":["webpack://./src/app/air/modules/common/component/common-dialog/air-common-dialog.component.scss"],"names":[],"mappings":"AACI;EACI,8BAAA;AAAR;;AAII;EACI,qBAAA;AADR;;AAIA;EACI,yBAAA;AADJ;;AAIA;EACI,cAAA;EACA,sBAAA;EACA,qBAAA;AADJ;;AAIA;EACI,iBAAA;EACA,iBAAA;AADJ;;AAIA;EACI,yBAAA;EACA,qBAAA;EACA,WAAA;AADJ;;AAIA;EACI,kBAAA;EACA,WAAA;AADJ","sourcesContent":["::ng-deep {\n    .p-dialog .p-dialog-header {\n        justify-content: space-between;\n    }   \n}\n#sessionTimeout{\n    ::ng-deep .p-dialog{\n        width: 40% !important;\n    }\n}\n.bdp-save {\n    background-color: #2d74ff;\n}\n\n.bdp-reset {\n    color: #1d2125;\n    background-color: #fff;\n    border-color: #1d2125;\n}\n\n.p-dialog .p-dialog-header {\n    font-size: 1.5rem;\n    font-weight: bold;\n}\n\n.p-dialog .p-button-primary {\n    background-color: #007bff;\n    border-color: #007bff;\n    color: #fff;\n}\n\n.p-dialog .p-button-outlined {\n    border-color: #ccc;\n    color: #333;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
